import React, { useState, useRef } from 'react'
import PageLayout from '@layouts/PageLayout'
import PropTypes from 'prop-types'
import { useLocalization } from '@contexts/LocalizationContext'
import {
  Button,
  Input,
  Table,
  Dropdown,
  Space,
  Popconfirm,
  message,
} from 'antd'
import Fetch from '@components/CRUD/Fetch'
import { EllipsisOutlined } from '@ant-design/icons'
import Create from './Create'
import EditNameShop from './EditNameStore'
import EditPassword from './EditPassword'
import { client } from '@utils/client'

const List = () => {
  const { t } = useLocalization()
  const defaultPage = 1
  const defaultPageSize = 10
  const fetchRef = useRef(null)
  const [page, setpage] = useState(defaultPage)
  const [pageSize, setpageSize] = useState(defaultPageSize)
  const [modalCreateOpen, setmodalCreateOpen] = useState(false)
  const [modalEditNameShopOpen, setmodalEditNameShopOpen] = useState(false)
  const [modalEditPasswordOpen, setmodalEditPasswordOpen] = useState(false)
  const [dataShop, setDataShop] = useState({})
  const [keyword, setKeyword] = useState()

  const fetch = async ({ page, pageSize, keyword }) => {
    const result = await client
      .get('/shop', {
        params: {
          page: page,
          limit: pageSize,
          keyword: keyword,
        },
      })
      .then((res) => res.data)

    return result
  }

  const columns = [
    {
      title: t('rewards.shop.column.no'),
      // dataIndex: 'no',
      key: 'no',
      width: 75,
      render: function no(_text, _record, index) {
        return <p>{pageSize * (page - 1) + index + 1}</p>
      },
    },
    {
      title: t('rewards.shop.column.shopName'),
      dataIndex: 'name',
      key: 'name',
      width: 192,
    },
    {
      title: t('rewards.shop.column.userID'),
      dataIndex: 'username',
      key: 'username',
      width: '70%',
    },

    {
      title: '',
      key: 'edit',
      width: 61,
      render: function shopEvent(record) {
        const items = [
          {
            key: '1',
            label: (
              <a
                onClick={() => {
                  setmodalEditNameShopOpen(true)
                  setDataShop(record)
                }}
              >
                <Space>{t('rewards.shop.create.editNameShop')}</Space>
              </a>
            ),
          },

          {
            type: 'divider',
          },

          {
            key: '2',
            label: (
              <a
                onClick={() => {
                  setmodalEditPasswordOpen(true)
                  setDataShop(record)
                }}
              >
                <Space>{t('rewards.shop.create.editPassword')}</Space>
              </a>
            ),
          },
          {
            type: 'divider',
          },
          {
            key: '3',
            label: (
              <div>
                <Popconfirm
                  placement="left"
                  title={t('rewards.shop.confirm.deleteConfirmQuestion')}
                  okText={t('rewards.shop.confirm.okText')}
                  cancelText={t('rewards.shop.confirm.cancelText')}
                  onConfirm={() => onDelete(record.id)}
                >
                  <a href="#">
                    <Space
                      style={{
                        width: '100%',
                        color: '#56B9C3',
                        justifyContent: 'center',
                      }}
                    >
                      {t('rewards.shop.create.delete')}
                    </Space>
                  </a>
                </Popconfirm>
              </div>
            ),
          },
        ]
        return (
          <>
            <div>
              <Dropdown
                menu={{
                  items,
                }}
                trigger="click"
              >
                <EllipsisOutlined
                  style={{ fontSize: '32px', color: '#005596' }}
                />
              </Dropdown>
            </div>
          </>
        )
      },
    },
  ]
  const handleReload = () => {
    fetchRef.current.reload()
  }
  const onDelete = async (id) => {
    try {
      await client.delete(`/shop/${id}`)
      message.success(t('rewards.shop.confirm.deleteSuccess'))
      handleReload()
    } catch (e) {
      message.error(t('rewards.shop.confirm.deleteeFailed'))
    }
  }
  const handleChange = (pagination) => {
    console.log(pagination)
    setpage(pagination.current)
    setpageSize(pagination.pageSize)
  }

  const style = {
    btnAddData: { borderRadius: '5px', width: '165px', height: '40px' },
    divSearch: {
      width: '100%',
      display: 'flex',
      gap: '20px',
      marginBottom: '20px',
    },
    btnSearch: { borderRadius: '5px', width: '136px', height: '40px' },
    inputSearch: { width: '100%', borderRadius: '6px', height: '40px' },
  }

  return (
    <>
      <Fetch fetch={fetch} params={{ page, pageSize, keyword }} ref={fetchRef}>
        {({ data, total }) => (
          <>
            <PageLayout
              title={t('rewards.shop.listScreen.title')}
              shownBack={false}
              extra={[
                <Button
                  type="primary"
                  key="modalCreate"
                  icon=""
                  onClick={() => setmodalCreateOpen(true)}
                  style={style.btnAddData}
                >
                  {t('rewards.list.addData')}
                </Button>,
              ]}
            >
              <div style={style.divSearch}>
                <SearchInput fetchData={(keyword) => setKeyword(keyword)} />
              </div>

              <Table
                rowKey="id"
                columns={columns}
                dataSource={data}
                onChange={handleChange}
                pagination={{
                  defaultCurrent: defaultPageSize,
                  defaultPageSize: defaultPageSize,
                  current: page,
                  pageSize,
                  total,
                }}
              ></Table>
            </PageLayout>
          </>
        )}
      </Fetch>

      <Create
        modalCreateOpen={modalCreateOpen}
        setmodalCreateOpen={setmodalCreateOpen}
      />
      <EditNameShop
        modalEditNameShopOpen={modalEditNameShopOpen}
        setmodalEditNameShopOpen={setmodalEditNameShopOpen}
        dataShop={dataShop}
      />
      <EditPassword
        modalEditPasswordOpen={modalEditPasswordOpen}
        setmodalEditPasswordOpen={setmodalEditPasswordOpen}
        dataShop={dataShop}
      />
    </>
  )
}
const SearchInput = ({ fetchData }) => {
  const { t } = useLocalization()
  const [keyword, setKeyword] = useState()
  const style = {
    btnSearch: { borderRadius: '5px', width: '136px', height: '40px' },
    inputSearch: { width: '100%', borderRadius: '6px', height: '40px' },
  }

  return (
    <>
      <Input
        defaultValue={keyword}
        placeholder=""
        style={style.inputSearch}
        onChange={(e) => setKeyword(e.target.value)}
      />

      <Button
        style={style.btnSearch}
        type="primary"
        key="reload"
        onClick={() => fetchData(keyword)}
      >
        {t('rewards.list.search')}
      </Button>
    </>
  )
}

SearchInput.propTypes = {
  fetchData: PropTypes.func,
}
export default List
